// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"Cb-z","heading":"Db-z","screenReadersOnly":"Eb-z"};